define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/riq-select-user/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/riq-select-user/1.0.0/index.css'
], function riqSelectUserModule(app, html, css) {
  'use strict';

  app.registerComponent('riqSelectUser', {
    bindings: {
      profiles: '<',
      selectedProfile: '<',
      selectProfile: '&',
      addChild: '&',
      gotoLibrary: '&',
      addChildArr: '<'
    },
    controller: 'riqSelectUserController',
    template: html
  });

  app.registerController('riqSelectUserController', [
    '$scope',
    '$element',
    'compileService',
    function riqSelectUserController($scope, $element, compileService) {
      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
